import React from 'react';
import { SimpleToolboxTooltip } from './SimpleTooltip';
import TipsTooltip from './TipsTooltip';
import ExpandingStepsTooltip from './ExpandingStepsTooltip';
import SignatureToolboxTooltip from './SignatureToolboxTooltip';
import SelfServeTooltipTourConstants from './TooltipTourConstants';


const SelfServeTooltipTour = () => {
  const textToolboxTipSections = [
    {
      text: "Click to place the answer box on your document where you want your recipient's answer.",
      image: '/images/self-serve-builder/tooltip-tour-images/tb1-2x.png',
    },
    {
      text: 'Write a question to help your recipient fill in the blank.',
      additionalText: '(The recipient will not answer on the PDF directly.)',
      image: '/images/self-serve-builder/tooltip-tour-images/tb2-2x.png',
    },
    {
      text: 'Click done to finish.',
      image: '/images/self-serve-builder/tooltip-tour-images/tb3-2x.png',
    },
  ];
  const multChoiceToolboxTipSections = [
    {
      text: 'Click to place the multiple choice answer boxes over the choices associated with the question.',
      image: '/images/self-serve-builder/tooltip-tour-images/mc1-2x.png',
    },
    {
      text: 'Write a question to help your recipient pick one choice.',
      additionalText: '(The recipient will not answer on the PDF directly.)',
      image: '/images/self-serve-builder/tooltip-tour-images/mc2-2x.png',
    },
    {
      text: 'Name the choices for this question.',
      image: '/images/self-serve-builder/tooltip-tour-images/mc3-2x.png',
    },
    {
      text: 'Click done to finish.',
      image: '/images/self-serve-builder/tooltip-tour-images/mc4-2x.png',
    },
  ];
  const checkboxToolboxTipSections = [
    {
      text: 'Click to place the checkbox answers over the selections associated with the question.',
      image: '/images/self-serve-builder/tooltip-tour-images/cb1-2x.png',
    },
    {
      text: 'Write a question to help your recipient pick one or more selections.',
      additionalText: '(The recipient will not answer on the PDF directly.)',
      image: '/images/self-serve-builder/tooltip-tour-images/cb2-2x.png',
    },
    {
      text: 'Name the selections for this question.',
      image: '/images/self-serve-builder/tooltip-tour-images/cb3-2x.png',
    },
    {
      text: 'Click done to finish.',
      image: '/images/self-serve-builder/tooltip-tour-images/cb4-2x.png',
    },
  ];
  const signatureToolboxTipSections = [
    {
      text: 'Click to place the signature box where you want your recipient to sign.',
      image: '/images/self-serve-builder/tooltip-tour-images/sig1-2x.png',
    },
    {
      text: 'Signatures are automatically numbered.',
      image: '/images/self-serve-builder/tooltip-tour-images/sig2-2x.png',
    },
  ];
  const toolboxTips = [
    {
      name: 'Textbox ›',
      type: SelfServeTooltipTourConstants.TOOLBOX_TEXTBOX_TOOLTIP,
    },
    {
      name: 'Multiple Choice ›',
      type: SelfServeTooltipTourConstants.TOOLBOX_MULT_CHOICE_TOOLTIP,
    },
    {
      name: 'Checkbox ›',
      type: SelfServeTooltipTourConstants.TOOLBOX_CHECKBOX_TOOLTIP,
    },
    {
      name: 'Signature ›',
      type: SelfServeTooltipTourConstants.TOOLBOX_SIGNATURE_TOOLTIP,
    },
  ];
  return (
    <div>
      <ExpandingStepsTooltip
        border
        bsClass="expanding-steps-tooltip"
        className="preview-toolbox-tooltip-tour"
        effect="solid"
        expandableSections={textToolboxTipSections}
        id="toolboxTextTooltip"
        leftOffset={0}
        tooltipName={SelfServeTooltipTourConstants.TOOLBOX_TEXTBOX_TOOLTIP}
        tooltipPlacement="right"
        topOffset={0}
        type="light"
      />
      <ExpandingStepsTooltip
        border
        bsClass="expanding-steps-tooltip"
        className="preview-toolbox-tooltip-tour"
        effect="solid"
        expandableSections={multChoiceToolboxTipSections}
        id="toolboxMultipleChoiceTooltip"
        leftOffset={0}
        tooltipName={SelfServeTooltipTourConstants.TOOLBOX_MULT_CHOICE_TOOLTIP}
        tooltipPlacement="right"
        topOffset={0}
        type="light"
      />
      <ExpandingStepsTooltip
        border
        bsClass="expanding-steps-tooltip"
        className="preview-toolbox-tooltip-tour checkbox"
        effect="solid"
        expandableSections={checkboxToolboxTipSections}
        id="toolboxCheckTooltip"
        leftOffset={0}
        tooltipName={SelfServeTooltipTourConstants.TOOLBOX_CHECKBOX_TOOLTIP}
        tooltipPlacement="right"
        topOffset={50}
        type="light"
      />
      <SignatureToolboxTooltip
        border
        bsClass="signature-toolbox-tooltip"
        className="preview-toolbox-tooltip-tour middle-arrow"
        effect="solid"
        id="toolboxSignatureTooltip"
        leftOffset={0}
        sections={signatureToolboxTipSections}
        tooltipName={SelfServeTooltipTourConstants.TOOLBOX_SIGNATURE_TOOLTIP}
        tooltipPlacement="right"
        topOffset={95}
        type="light"
      />
      <TipsTooltip
        border
        bsClass="tips-tooltip"
        className="preview-toolbox-tooltip-tour tips-tooltip middle-arrow"
        effect="solid"
        id="toolboxTipsListTooltip"
        leftOffset={0}
        tips={toolboxTips}
        tooltipName={SelfServeTooltipTourConstants.TOOLBOX_TIPS_LIST_TOOLTIP}
        tooltipPlacement="right"
        topOffset={68}
        type="light"
      />
      <SimpleToolboxTooltip
        border
        bsClass="simple-tooltip"
        className="preview-toolbox-tooltip-tour simple"
        effect="solid"
        id="toolboxTipsTooltip"
        leftOffset={0}
        tooltipName={SelfServeTooltipTourConstants.TOOLBOX_TIPS_TOOLTIP}
        tooltipPlacement="right"
        tooltipText="Click here at any time for tips on how to build your template."
        type="light"
      />
    </div>
  );
};

export default SelfServeTooltipTour;



// WEBPACK FOOTER //
// ./src-react/SelfServeTooltipTour/index.jsx